


























import Vue from 'vue';
import LandingHeader from '@/components/LandingHeader.vue';
import BottomButton from '@/components/BottomButton.vue';
import ChangePhoneForm, { ChangePhoneFormEvent } from '@/components/forms/ChangePhoneForm.vue';
import VIEWS_NAMES from '@/router/viewsNames';
import { UserInfo } from '@/store/modules/user/state';
import { allowedRoutesGuard } from '@/helpers/guards';

export default Vue.extend({
  components: {
    LandingHeader,
    ChangePhoneForm,
    BottomButton,
  },
  data() {
    return {
      form: {} as ChangePhoneFormEvent,
      changePhoneError: false,
      isLoading: false,
    };
  },
  beforeRouteEnter: allowedRoutesGuard([VIEWS_NAMES.CONFIRMATION_CODE], VIEWS_NAMES.HOME),
  computed: {
    phone(): string {
      return this.$store.getters.user.phone;
    },
    isContinueEnabled(): boolean {
      const { hasErrors, phone } = this.form;

      const isFormFilled = Boolean(phone);

      return !hasErrors && isFormFilled;
    },
  },
  methods: {
    async continueHandler() {
      const { phone } = this.form;

      const user: UserInfo = { phone };

      this.isLoading = true;

      try {
        await this.$store.dispatch('UPSERT_USER', { user });

        await this.$store.dispatch('SEND_LOGIN_CODE', { selectedChannel: 'phone' });

        this.$router.push({ name: VIEWS_NAMES.CONFIRMATION_CODE });
      } catch {
        this.changePhoneError = true;
      } finally {
        this.isLoading = false;
      }
    },
    inputHandler(event: ChangePhoneFormEvent) {
      this.changePhoneError = false;
      this.form = event;
    },
  },
});
